module.exports = __webpack_public_path__ + "media/images/themes/eu-watch-7bf145142e4b09909341e907a77a5ace.png";